export const home = {
  nav: {
    features: 'Funktionen',
    pricing: 'Preise',
    testimonials: 'Erfolge',
    dashboard: 'Dashboard',
  },
  hero: {
    badge: 'KI-gestützter Ernährungscoach',
    title: 'Dein persönlicher',
    titleHighlight: 'Ernährungscoach',
    subtitle: 'KI-gestützte Ernährungspläne, personalisierte Rezepte und intelligente Einkaufslisten für deine Gesundheitsziele',
    dashboardAlt: 'NutriBot Dashboard Vorschau',
    ctaGetStarted: 'Jetzt starten',
    ctaLearnMore: 'Mehr erfahren',
    ctaRegister: 'Jetzt starten',
    ctaLogin: 'Anmelden',
    stats: {
      satisfaction: '97%',
      satisfactionLabel: 'Zufriedenheit',
      users: '10k+',
      usersLabel: 'Nutzer',
      plans: '30',
      plansLabel: 'Tage Pläne',
    },
  },
  features: {
    title: 'Revolutionäre Funktionen',
    subtitle: 'Erleben Sie die Zukunft der Ernährungsplanung mit modernster KI-Technologie und einem personalisierten Ansatz.',
    aiPersonalization: {
      title: 'KI-gestützte Personalisierung',
      description: 'Fortschrittliche Algorithmen erstellen Ernährungspläne, zugeschnitten auf Ihre einzigartigen Ziele, Vorlieben und Ernährungseinschränkungen.',
    },
    chatbot: {
      title: '24/7 NutriBot-Assistent',
      description: 'Erhalten Sie jederzeit sofortige Antworten, Plananpassungen und Ernährungsberatung von unserem intelligenten Chatbot.',
    },
    pdfReports: {
      title: 'Professionelle PDF-Berichte',
      description: 'Erhalten Sie detaillierte Ernährungsberichte mit Einkaufslisten, Meal-Prep-Guides und Fortschrittsverfolgung.',
    },
    mealPlans: {
      title: '30-Tage-Ernährungspläne',
      description: 'Vollständige 30-Tage-Pläne mit Frühstück, Mittagessen, Abendessen, Zutaten und Kalorien für jeden Tag.',
    },
    customization: {
      title: 'Individuelle Anpassung',
      description: 'Berücksichtigt Allergien, Intoleranzen, Ernährungstyp, Kultur und persönliche Vorlieben für maximale Zufriedenheit.',
    },
    tracking: {
      title: 'Fortschrittsverfolgung',
      description: 'Verfolgen Sie Ihren Gesundheitsweg mit detaillierten Analysen und personalisierten Empfehlungen.',
    },
  },
  pricing: {
    title: 'Flexible Preise für jeden Bedarf',
    subtitle: 'Wählen Sie den Plan, der am besten zu Ihren Zielen passt. Jeder Plan ist transparent und bietet echten Mehrwert.',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    yearlyDiscount: '-20%',
    yearlyBadge: '20% Rabatt bei Jahreszahlung',
    perMonth: 'pro Monat',
    perYear: 'pro Jahr',
    basic: {
      name: 'Basic Plan',
      description: 'Perfekt für den Einstieg in die personalisierte Ernährung.',
      monthlyPrice: 'CHF 14.90',
      yearlyPrice: 'CHF 142.56',
      yearlyOriginal: 'CHF 178.80',
      yearlySavings: 'Du sparst CHF 36.24',
      features: {
        1: 'Statische Ernährungspläne',
        2: 'Basis-Funktionen',
        3: 'Kalorien & Zutaten pro Tag',
        4: 'Berücksichtigt Allergien & Vorlieben',
      },
      notIncluded: {
        1: 'Kein Zugriff auf NutriBot',
        2: 'Keine Echtzeit-Anpassungen',
        3: 'Keine Einkaufslisten',
      },
      cta: 'Basic wählen',
    },
    vip: {
      name: 'VIP Plan',
      badge: 'EMPFOHLEN',
      description: 'Komplette Ernährungslösung mit unbegrenzten Möglichkeiten.',
      monthlyPrice: 'CHF 29.90',
      yearlyPrice: 'CHF 287.04',
      yearlyOriginal: 'CHF 358.80',
      yearlySavings: 'Du sparst CHF 71.76',
      features: {
        1: 'Voller Zugriff auf NutriBot',
        2: 'Wöchentliche VIP-Rezepte',
        3: 'Intelligente Einkaufslisten',
        4: 'Echtzeit-Plananpassungen',
        5: 'Motivations- & Coaching-Inhalte',
        6: 'PDF-Export für alle Pläne',
        7: 'Dashboard mit Fortschritt',
        8: '24/7 NutriBot Chat-Assistent',
      },
      cta: 'VIP wählen',
    },
  },
  testimonials: {
    title: 'Erfolgsgeschichten unserer Nutzer',
    subtitle: 'Echte Ergebnisse, echte Motivation. Unsere Community erreicht ihre Ziele mit personalisierter Unterstützung.',
    user1: {
      name: 'Anna Müller',
      location: 'Zürich, Schweiz',
      plan: 'VIP-Plan',
      text: 'Ich habe in 3 Monaten 8 kg gesund abgenommen und fühle mich energiegeladen. Die personalisierten Pläne sind ein Game-Changer!',
      stats: 'Vorher: 74 kg • Nachher: 66 kg',
    },
    user2: {
      name: 'Marco Rossi',
      location: 'Basel, Schweiz',
      plan: 'VIP-Plan',
      text: 'Als Marathonläufer bekomme ich dank NutriBot genau die Makros, die ich brauche. Die wöchentlichen Updates halten mich auf Kurs.',
      stats: 'Muskelaufbau: +3kg in 2 Monaten',
    },
    user3: {
      name: 'Julia Weber',
      location: 'Bern, Schweiz',
      plan: 'VIP-Plan',
      text: 'Ich habe endlich einen Ernährungsplan, der zu meinem Alltag passt. Die PDFs mit Einkaufslisten sparen mir jede Woche Zeit.',
      stats: 'Mehr Energie • Bessere Verdauung',
    },
    stats: {
      satisfaction: '97%',
      satisfactionLabel: 'Kundenzufriedenheit',
      adherence: '89%',
      adherenceLabel: 'Durchschnittliche Plan-Treue',
      recommendation: '92%',
      recommendationLabel: 'Empfehlungsrate',
    },
  },
  footer: {
    description: 'Verbessern Sie Ihre Gesundheit mit KI-gestützten, personalisierten Ernährungsplänen.',
    product: {
      title: 'Produkt',
      features: 'Funktionen',
      pricing: 'Preise',
      dashboard: 'Dashboard',
    },
    company: {
      title: 'Unternehmen',
      about: 'Über uns',
      contact: 'Kontakt',
      privacy: 'Datenschutz',
    },
    support: {
      title: 'Support',
      help: 'Hilfe-Center',
      faq: 'FAQ',
    },
    copyright: '© 2026 NutriBot. Alle Rechte vorbehalten.',
    poweredBy: 'Powered by Readdy',
  },
};
